<template>
    <div v-if="loading">
        <div class="loader"></div>
    </div>
    <div v-else-if="teamData && Object.keys(teamData).length > 0" class="headed-table w-100">
        <table class="w-100">
            <thead>
                <tr>
                    <th class="col-2">
                        <small v-if="is_job" >Staff on Job</small>
                        <small v-else >Staff in Company</small>
                    </th>
                    <th class="col-1">
                        <div class="d-flex justify-content-center">
                            <small>Training Certificates</small>
                        </div>
                    </th>
                    <th class="col-1">
                        <div class="d-flex justify-content-center">
                            <small>Plant & Tools</small>
                        </div>
                    </th>
                    <th class="col-1">
                        <div class="d-flex justify-content-center">
                            <small class="text-break">Toolbox talks</small>
                        </div>
                    </th>
                    <th class="col-1">
                        <div class="d-flex justify-content-center">
                            <small class="text-break">Expired</small>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="head-table--row"  v-for="user in teamData"  :key="user.id">
                    <td class="col-2">
                        <a :href="generateRouteUser(user.id)" class="people-list--item-title" target="_blank">
                            <h5 class="people-list--item-title-name">{{user.full_name}}</h5>
                            <h6 class="people-list--item-title-email">{{user.email}}</h6>
                        </a>
                    </td>
                    <td  class="col-1">
                        <div class="d-flex justify-content-center">
                            <div class="badge badge--sm badge--primary"> {{ user.total_amount_active_certificates }} </div>
                        </div>
                    </td>
                    <td  class="col-1">
                        <div class="d-flex justify-content-center">
							<div class="badge badge--sm badge--primary"> {{ user.total_amount_active_tools_on_site }} </div>
                        </div>
                    </td>
                    <td  class="col-1">
                        <div class="d-flex justify-content-center">
							<div class="badge badge--sm badge--primary"> {{ user.total_amount_toolbox_talks_submissions }} </div>
                        </div>
                    </td>
                    <td  class="col-1">
                        <div class="d-flex justify-content-center">
							<div class="badge badge--sm" :class="user.total_amount_expired_forms > 0 ? 'badge--negative' : 'badge--secondary'"> {{ user.total_amount_expired_forms }} </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div v-else class="headed-table w-100">
        <table class="d-flex justify-content-center">
            <div class="text-center">
                <h5 class="m-4 mx-auto text-dark">No staff assigned to job</h5>
            </div>
        </table>
    </div>
</template>

<script>
    import Loader from "../general_components/Loader";
    import generateRoute from "../../helpers/routes";

	export default {
		name: "StaffMatrixTable",
		components: {Loader},
        props: {
			loading:true,
			company_staff:null,
			preloaded:null,
			store_url:null,
			is_job:null,
            teamData:null,
            create_job: null,
            show_user_url: null,
        },
        methods: {
            generateRouteUser(userId) {
                return generateRoute(this._props.show_user_url, userId);
            }
        }
    }
</script>
